import { Translate } from "../i18n";
import { Problem } from "../model/problem";

/**
 * Normalizes a slice's `error` (a plain string or a `Problem`) into a
 * title/details pair for the error modal.
 *
 * Guards against the "empty modal" case: when the backend returns an error with
 * no body (a 500/502/504, a gateway timeout, a bodyless 401/400, or a network
 * error), the slice ends up with an empty string — so we fall back to a generic
 * "Server error" title instead of rendering a blank dialog. That fallback is
 * the one part of the pair this app writes, so it takes the translate function;
 * a title and detail the backend supplied are passed through as they came.
 */
export const getErrorMessage = (
    error: string | Problem | unknown | undefined,
    t: Translate
): { title: string; details: string } => {
    const fallbackTitle = t("error.server");

    if (typeof error === "string") {
        return { title: error || fallbackTitle, details: "" };
    }

    const apiError = error as Problem | undefined;
    return {
        title: apiError?.title ?? fallbackTitle,
        details: apiError?.detail ?? ""
    };
};
